// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import cheader from '@/components/Header';
import Theader from '@/components/Header/third';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import './permission';
// scss 变量
import './assets/styles/index.scss';
import './assets/styles/editor.css';
// icon
import './assets/icons';
import { pxTovw, urlTogetCampusCode } from './utils/util';

// loading指令
import { Loading } from 'element-ui';

// h5与app通信的方法
import Bridge from './utils/webViewJsBridge';
Vue.prototype.$bridge = Bridge;
Vue.use(Loading);

Vue.use(VueAwesomeSwiper, /* { default options with global component } */);
Vue.config.productionTip = false;
Vue.component('CHeader', cheader);
Vue.component('THeader', Theader);

// 全局方法挂载
Vue.prototype.pxTovw = pxTovw;
Vue.prototype.urlTogetCampusCode = urlTogetCampusCode;
// Vue.prototype.$jsbridge = JsBridge;
Vue.prototype.$platform = window.navigator.userAgent;
// import './utils/vconsole'; // 移动端调试

// import VConsole from 'vconsole/dist/vconsole.min.js';
// new VConsole();

// 获取mock数据
// require('./mock.js');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js